import React from 'react';
import moment from 'moment';
export const TABLE_COLUMN = [
  {
    Header: "Name",
    id: "corporateName",
    accessor: p => <p className="text-truncate" style={{ maxWidth: '150px' }}>{p.corporateName}</p>
  },
  {
    Header: "Created At",
    id: "createdAt",
    accessor: d => <div>{moment(d.createdAt).format('DD-MM-YYYY')}</div>
  },
  /* {
      Header: "City",
      id: "city",
      accessor: d => <div title={d.city}>{d.city}</div>
  }, */
  {
    Header: "Created By",
    id: "createdBy",
    // maxWidth: 100,
    accessor: p => <div>{p.createdBy}</div>,

  },
  {
    Header: "Status",
    id: "status",
    accessor: p => <div>{p.status}</div>,
    className: 'center'
  },
  /* {
    Header: "Transaction Report",
    id: "transactionReport",
    accessor: p => <button className="btn btn-upload text-primary" onClick={() => that.handleUploadNew(p, true)}>
      <i className="fa fa-plus pr-2" />
      <span>Upload new</span>
    </button>,
    className: 'center'
  }, */
  /* {
    Header: "Action",
    id: "Edit",
    maxWidth: 80,
    accessor: p => <Link tag="button" id={p.id} to={`./onboarding/edit/${p.id}/companysetup`}><i className="icon-edit border border-primary radius-4 p-2 font-size-16" color="primary" /></Link>,
  } */
];
export const DEFAULT_PAGE_SIZE = 10